import React, { Component } from "react";

export default class Winners extends Component {
  constructor(props) {
    super(props);
    this.state = { winners: {} };
  }
  async componentDidMount() {
    const response = await fetch("json/winners.json");
    const winners = await response.json();
    // waits until the request completes...
    this.setState({
      winners: winners.winners,
    });
  }
  createWinnersList = (winners, winType) => {
    const { language } = this.props;
    if (winType === "miljoniloos") {
      return (
        <ul className="winners--list">
          {Object.keys(winners[winType]["tickets"]).map((winner, key) => {
            return (
              <li className="winners--item" key={key}>
                <div className="winners--nr">{key + 1}</div>
                <div className="winners--info">
                  <span className="winners--item__id">
                    {winners[winType]["tickets"][winner]?.id_nr}
                  </span>
                  <span className="winners--item__type">
                    {winners[winType]["tickets"][winner].type}
                  </span>
                </div>
              </li>
            );
          })}
        </ul>
      );
    } else if (winType === "lisaloos") {
      return (
        <>
          {Object.keys(winners[winType]).map((ticketType, tKey) => {
            return (
              <React.Fragment key={tKey}>
                <h4 className="extraWinnersTitle">
                  {" "}
                  {this.alterWinTitle(ticketType)}
                </h4>
                <ul className="winners--list extraWinners">
                  {Object.keys(winners[winType][ticketType]).map(
                    (winner, keyV) => {
                      return (
                        <li className="winners--item" key={keyV}>
                          <div className="winners--nr">{keyV + 1}</div>
                          <div className="winners--info">
                            <span className="winners--item__id">
                              {winners[winType]?.[ticketType][winner]?.id_nr}
                            </span>
                            <span className="winners--item__type">
                              {winners[winType]?.[ticketType][winner].type}
                            </span>
                          </div>
                        </li>
                      );
                    }
                  )}
                </ul>
              </React.Fragment>
            );
          })}
        </>
      );
    } else {
      return "";
    }
  };

  alterWinTitle(ticketType) {
    const { language } = this.props;
    switch (ticketType) {
      case "tickets_60000":
        return language === "et"
          ? "Volkswagen ID.4 võidupiletid"
          : "Билеты с выигрышем Volkswagen ID.4";
      case "tickets_10000":
        return language === "et"
          ? "10 000 euro võidupiletid"
          : "Билеты с выигрышем 10 000 евро";
      case "tickets_5000":
        return language === "et"
          ? "5 000 euro võidupiletid"
          : "Билеты с выигрышем 5 000 евро";
      default:
        return "";
    }
  }

  renderWinnerList = (ticketsType) => {
    const { language } = this.props;
    const { winners } = this.state;

    return Object.keys(winners).map((winType, index) => {
      return (
        <div key={index}>
          <div className="winnersTitle">
            {winType === "miljoniloos" ? (
              <h4 className="text text--center">
                {language === "et"
                  ? "Miljoniloosi võidupilet(id)"
                  : "Выигрышный(-е) билет(-ы) розыгрыша Миллиона"}
              </h4>
            ) : (
              <h4 className="text text--center">
                {language === "et"
                  ? "Lisaloosi võidupiletid"
                  : "Выигрышные билеты дополнительного розыгрыша"}
              </h4>
            )}{" "}
          </div>
       
          {this.createWinnersList(winners, winType)}
        </div>
      );
    });
  };

  render() {
    const { winners } = this.state;
    const { language } = this.props;
    return (
      <div className="winners" id="winners">
        <h2 className="text--center">
          {" "}
          {language === "et" ? "Võitjad" : "Победители"}
        </h2>
      
        {Object.keys(winners).length === 0 && winners.constructor === Object ? (
          <p style={{ textAlign: "center" }}>
            {language === "et" ? (
              <>
                Võitjad selguvad 7. jaanuaril, 2024 TV3 telesaates “Vikinglotto
                Aastaloos”.
                <br />
                Võidupiletite info avaldame siin 08.01.2024.{" "}
              </>
            ) : (
              <>
                Победители определятся 7 января 2024 года в телепередаче
                «Vikinglotto – Розыгрыш Года» на TV3.
                <br />
                Информация о выигрышных билетах будет размещена здесь
                08.01.2024.
              </>
            )}
          </p>
        ) : (
          <>
            {this.renderWinnerList()}
            <div className="winnersInfo">
              {language === "et" ? (
                <p>
                  Võite saab vormistada AS Eesti Loto kontoris (Hallivanamehe 4,
                  Tallinn) tööpäeviti kell 10.00-16.30 või elektroonselt
                  digiallkirjastatud avalduse alusel. Võidu vormistamise
                  lõpptähtaeg on 15. veebruar 2024. Võidu kättesaamise aluseks
                  on isikut tõendav dokument.
                </p>
              ) : (
                <p>
                  Выигрыши можно оформить в конторе AS Eesti Loto (Халливанамехе
                  4, Таллинн) в рабочие дни с 10.00 до 16.30 или электронным
                  путем на основании подписанного дигитально заявления.
                  Последний день оформления выигрышей – 15.02.2024. Для
                  получения выигрыша следует предъявить удостоверяющий личность
                  документ.
                </p>
              )}
            </div>
          </>
        )}
      </div>
    );
  }
}
